import { render, staticRenderFns } from "./exhibitionDescMobile.vue?vue&type=template&id=77557bf4&scoped=true"
import script from "./exhibitionDescMobile.vue?vue&type=script&lang=js"
export * from "./exhibitionDescMobile.vue?vue&type=script&lang=js"
import style0 from "./exhibitionDescMobile.vue?vue&type=style&index=0&id=77557bf4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77557bf4",
  null
  
)

export default component.exports